import { useState } from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import Card from "@mui/material/Card";

// MindPlus components
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";

// MindPlus examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";

// NewArticle page components
import ProgramInfo from "layouts/articles/new-article/components/ProgramInfo";

function NewArticle() {
  const saveProgram = () => {};

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox mt={5} mb={9}>
        <Grid container justifyContent="center">
          <Grid item xs={12} lg={12}>
            <MDBox mb={2}>
              <Grid container spacing={3} alignItems="center">
                <Grid item xs={12} lg={6}>
                  <MDTypography variant="h4" fontWeight="medium">
                    New Article
                  </MDTypography>
                  <MDBox mt={1}>
                    <MDTypography variant="body2" color="text">
                      Page: (Article) Let's create an article with the below details.
                    </MDTypography>
                  </MDBox>
                </Grid>
              </Grid>
            </MDBox>
            <MDBox mt={-3}>
              <ProgramInfo />
            </MDBox>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default NewArticle;
